export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',
  TA_ADMIN: 'ta-admin',
  TA_USER: 'ta-user',
  ORG_ADMIN: 'org_admin',
  ORG_USER: 'org_user',
  HR_ADMIN: 'hr-admin',
  HR_USER: 'hr-user',
  FINANCE_ADMIN: 'finance-admin',
  FINANCE_USER: 'finance-user',
  EMPLOYEE: 'employee',
  // legacy roles mapping
  ADMIN: 'admin',
  MERCCHANTADMIN: 'merchantadmin'
};

export const ROLE_LOGIN_EMAILS = {
  [USER_ROLES.ADMIN]: 'admin@techapurva.com',
  [USER_ROLES.EMPLOYEE]: 'employee@techapurva.com'
};

const LOGIN_PROFILES = {
  [ROLE_LOGIN_EMAILS[USER_ROLES.ADMIN]]: {
    role: USER_ROLES.ADMIN,
    name: 'Admin User'
  },
  [ROLE_LOGIN_EMAILS[USER_ROLES.EMPLOYEE]]: {
    role: USER_ROLES.EMPLOYEE,
    name: 'Employee User'
  }
};

export const getLoginProfileByEmail = (email = '') => {
  const normalizedEmail = email.trim().toLowerCase();
  return LOGIN_PROFILES[normalizedEmail] || null;
};

export const normalizeRole = (role = '') => {
  const normalizedRole = role.trim().toLowerCase();
  if (normalizedRole === USER_ROLES.ADMIN || normalizedRole === 'super admin' || normalizedRole === 'super-admin' || normalizedRole === 'super_admin') {
    return USER_ROLES.SUPER_ADMIN;
  }
  if (normalizedRole === USER_ROLES.MERCCHANTADMIN || normalizedRole === 'org_admin') {
    return USER_ROLES.ORG_ADMIN;
  }
  if (normalizedRole === USER_ROLES.EMPLOYEE) {
    return USER_ROLES.EMPLOYEE;
  }
  return normalizedRole;
};

export const isLocalDev = () => {
  if (typeof window === 'undefined') {
    return process.env.NODE_ENV === 'development';
  }
  const host = window.location.hostname;
  return (
    process.env.NODE_ENV === 'development' ||
    host === 'localhost' ||
    host === '127.0.0.1' ||
    host.endsWith('.local') ||
    process.env.REACT_APP_ENABLE_DEV_LOGIN === 'true'
  );
};

export const DEV_ACCOUNTS = {
  TA_USER: {
    id: 101,
    roleKey: 'TA_USER',
    label: 'TA User',
    description: 'Read-only operational access',
    badge: 'Read Only',
    badgeColor: 'bg-amber-500/20 text-amber-300 border-amber-500/40',
    email: 'tauser@techapurva.com',
    username: 'ta_user',
    password: 'password123',
    role: USER_ROLES.TA_USER,
    roles: [USER_ROLES.TA_USER],
    userRoles: [USER_ROLES.TA_USER],
    name: 'TA User',
    firstName: 'TA',
    lastName: 'User',
    company: 'TechApurva Global',
    designation: 'TA Specialist',
    department: 'Operations',
    org_id: 1,
    orgId: 1,
    token: 'dev-token-ta-user'
  },
  SUPER_ADMIN: {
    id: 102,
    roleKey: 'SUPER_ADMIN',
    label: 'Super Admin',
    description: 'Platform wide administrative access',
    badge: 'Super Admin',
    badgeColor: 'bg-purple-500/20 text-purple-300 border-purple-500/40',
    email: 'superadmin@techapurva.com',
    username: 'super_admin',
    password: 'password123',
    role: USER_ROLES.SUPER_ADMIN,
    roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN],
    userRoles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN],
    name: 'Super Admin',
    firstName: 'Super',
    lastName: 'Admin',
    company: 'TechApurva Global',
    designation: 'System Administrator',
    department: 'Executive',
    org_id: 1,
    orgId: 1,
    token: 'dev-token-super-admin'
  },
  TA_ADMIN: {
    id: 103,
    roleKey: 'TA_ADMIN',
    label: 'TA Admin',
    description: 'TechApurva internal management access',
    badge: 'TA Admin',
    badgeColor: 'bg-blue-500/20 text-blue-300 border-blue-500/40',
    email: 'taadmin@techapurva.com',
    username: 'ta_admin',
    password: 'password123',
    role: USER_ROLES.TA_ADMIN,
    roles: [USER_ROLES.TA_ADMIN],
    userRoles: [USER_ROLES.TA_ADMIN],
    name: 'TA Admin',
    firstName: 'TA',
    lastName: 'Admin',
    company: 'TechApurva Global',
    designation: 'TA Administrator',
    department: 'Operations',
    org_id: 1,
    orgId: 1,
    token: 'dev-token-ta-admin'
  },
  MERCCHANTADMIN: {
    id: 104,
    roleKey: 'MERCCHANTADMIN',
    label: 'Merchant Admin',
    description: 'Organization and payroll manager',
    badge: 'Merchant Admin',
    badgeColor: 'bg-emerald-500/20 text-emerald-300 border-emerald-500/40',
    email: 'merchantadmin@techapurva.com',
    username: 'merchant_admin',
    password: 'password123',
    role: USER_ROLES.ORG_ADMIN,
    roles: [USER_ROLES.ORG_ADMIN, USER_ROLES.MERCCHANTADMIN],
    userRoles: [USER_ROLES.ORG_ADMIN, USER_ROLES.MERCCHANTADMIN],
    name: 'Merchant Admin',
    firstName: 'Merchant',
    lastName: 'Admin',
    company: 'Acme Merchant Corp',
    designation: 'Merchant Org Admin',
    department: 'Management',
    org_id: 2,
    orgId: 2,
    token: 'dev-token-merchant-admin'
  },
  EMPLOYEE: {
    id: 101,
    roleKey: 'EMPLOYEE',
    label: 'Employee',
    description: 'Employee salary and payslip access',
    badge: 'Employee',
    badgeColor: 'bg-teal-500/20 text-teal-300 border-teal-500/40',
    email: 'employee@techapurva.com',
    username: 'employee_user',
    password: 'password123',
    role: USER_ROLES.EMPLOYEE,
    roles: [USER_ROLES.EMPLOYEE],
    userRoles: [USER_ROLES.EMPLOYEE],
    name: 'Rajesh Kumar',
    firstName: 'Rajesh',
    lastName: 'Kumar',
    company: 'TechApurva Global',
    designation: 'Senior Software Engineer',
    department: 'Engineering',
    org_id: 10,
    orgId: 10,
    token: 'dev-token-employee'
  }
};

export const getDevAccountByCredentials = (identifier = '', password = '') => {
  if (!isLocalDev()) return null;
  const cleanId = String(identifier || '').trim().toLowerCase();
  if (!cleanId) return null;

  for (const account of Object.values(DEV_ACCOUNTS)) {
    const isIdMatch =
      account.email.toLowerCase() === cleanId ||
      account.username.toLowerCase() === cleanId ||
      (account.roleKey === 'SUPER_ADMIN' && (cleanId === 'admin' || cleanId === 'admin@techapurva.com' || cleanId === 'superadmin')) ||
      (account.roleKey === 'TA_ADMIN' && (cleanId === 'taadmin' || cleanId === 'ta-admin')) ||
      (account.roleKey === 'TA_USER' && (cleanId === 'tauser' || cleanId === 'ta-user')) ||
      (account.roleKey === 'MERCCHANTADMIN' && (cleanId === 'merchantadmin' || cleanId === 'merchant_admin' || cleanId === 'merchant')) ||
      (account.roleKey === 'EMPLOYEE' && (cleanId === 'employee' || cleanId === 'employee@techapurva.com' || cleanId === 'employee_user'));

    if (isIdMatch) {
      return account;
    }
  }
  return null;
};

